import React from "react";
// import { useNavigate } from "react-router-dom";

const DeleteInstruction = () => {

  // const navigate = useNavigate();

  // const handleBack = () => {
  //   navigate(-1);
  // };

  return (
    <div className="empty-screen">
      <div className="inner_terms_content" style={{ color: "#323232" }}>
        {/* <div className="inner_header">
        </div> */}
        <p><strong>Delete Instructions</strong></p>
        <p>
        1: Tap the purple circle → My Profile → “Delete Account.” 
        </p>
        <p>
        2: Confirm on the popup.
        </p>
        <p>
        3: This action is permanent 
        </p>
        <p>
        4: Your account will be permanently deleted.
        </p>
      </div>
    </div>
  );
};

export default DeleteInstruction;
